/* eslint-disable */
<template>
  <section class="shoprent-page">
    <vue-basic-alert :duration="400" ref="alert" />

    <!-- ── Not Logged In ── -->
    <div v-if="!user" class="login-prompt">
      <div class="login-card">
        <div class="login-icon">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
              d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"/>
          </svg>
        </div>
        <h2>Authentication Required</h2>
        <p>Please sign in to continue with your shop rent payment.</p>
        <router-link class="login-btn" to="/login" @click="scrollToTop()">Sign In to Continue</router-link>
      </div>
    </div>

    <!-- ── Logged In ── -->
    <div v-else class="page-body">

      <!-- Page Header -->
      <div class="page-header">
        <div class="header-left">
          <div class="header-bar"></div>
          <div>
            <p class="breadcrumb-label">Online Payments | මාර්ගගත ගෙවීම්</p>
            <h1 class="page-title">Shop Rents</h1>
            <p class="page-subtitle">කඩ කාමර කුලී ගෙවීම | Pay your shop rent online</p>
          </div>
        </div>
        <router-link to="/shoprentpayhistory" class="history-btn" @click="scrollToTop()">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
          </svg>
          Payment History
        </router-link>
      </div>

      <form id="ShopRentForm" @submit="handleSubmit" novalidate autocomplete="off">

        <!-- ── Sabha Selection ── -->
        <div class="form-card">
          <div class="card-header">
            <div class="step-badge">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/>
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"/>
              </svg>
            </div>
            <div>
              <h2 class="card-title">Select Pradeshiya Sabha</h2>
              <p class="card-desc">ඔබගේ කඩ කාමරය අයත් ප්‍රාදේශීය සභාව තෝරන්න | Choose the council your shop belongs to</p>
            </div>
          </div>
          <div class="field-group">
            <label class="field-label" for="pradeshiya">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"/>
              </svg>
              Pradeshiya Sabha <span class="req">*</span>
            </label>
            <div class="input-wrap">
              <select @change="AllShopData" v-model="rentObj.pra_sabha" id="pradeshiya"
                class="field-input select-input" :class="{ filled: rentObj.pra_sabha }">
                <option value="" disabled>Choose Sabha | සභාව තෝරන්න</option>
                <option v-for="ps in p_sabha" :key="ps.sb_code" :value="ps.sb_code">
                  {{ ps.sb_name_en }} | {{ ps.sb_name_sin }}
                </option>
              </select>
              <div class="select-chevron">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
                </svg>
              </div>
            </div>
            <p class="error-mess" v-if="errorObj.praErr.length > 0">{{ errorObj.praErr[0] }}</p>
          </div>
        </div>

        <!-- ── Shop List ── -->
        <div id="pay" style="display:none;">

          <div class="info-banner">
            <div class="info-icon">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
              </svg>
            </div>
            <div class="info-text">
              <p>The details of the shops registered under your name are shown below. Select one shop at a time and make separate payments for each shop.</p>
              <p class="sin-text">ඔබ තෝරාගත් ආයතනයේ ඔබේ නමින් ඇති කඩ කාමර වල තොරතුරු පහතින් පෙන්වයි. එක වරකදී එක කඩ කාමරයක් පමණක් තෝරා වෙන වෙනම ගෙවීම් සිදු කරන්න.</p>
            </div>
          </div>

          <!-- Empty state -->
          <div class="form-card empty-card" v-if="computedShopDetails.length === 0">
            <p class="empty-row">No shop records found for the selected Sabha.</p>
          </div>

          <!-- ── One card per shop ── -->
          <div v-for="r in computedShopDetails" :key="r.shop_details_id"
            class="shop-card" :class="{ 'shop-card--selected': checkVal.includes(r.shop_details_id) }">

            <!-- Card header: shop identity + select checkbox -->
            <div class="shop-card-top">
              <div class="shop-identity">
                <div class="shop-num-badge">{{ r.shop_number }}</div>
                <div class="shop-identity-info">
                  <p class="shop-place">{{ r.place }}</p>
                  <p class="shop-meta">
                    Last paid:&nbsp;<strong>{{ r.pay_year }} – {{ getMonthNameByNum(r.pay_month) }}</strong>
                    <span class="meta-sep">·</span>
                    Next due:&nbsp;<strong>{{ nextDueLabel(r) }}</strong>
                    <span class="meta-sep">·</span>
                    Monthly rent:&nbsp;<strong>Rs. {{ fmt(r.monthly_shop_rent) }}</strong>
                  </p>
                </div>
              </div>
              <label class="custom-check-wrap"
                :title="checkVal.includes(r.shop_details_id) ? 'Deselect' : 'Select to pay'">
                <input type="checkbox" v-model="checkVal" :value="r.shop_details_id" class="hidden-check"/>
                <div class="custom-check" :class="{ checked: checkVal.includes(r.shop_details_id) }">
                  <svg v-if="checkVal.includes(r.shop_details_id)"
                    xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M5 13l4 4L19 7"/>
                  </svg>
                </div>
              </label>
            </div>

            <!-- Two-column year breakdown -->
            <div class="year-columns">

              <!-- Previous Year column — only shown when there are prev-year amounts -->
              <div class="year-col" v-if="parseFloat(r.computed.prevYearTotal) > 0">
                <div class="year-col-header year-col-header--prev">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor" width="14" height="14">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
                  </svg>
                  Previous Year
                </div>
                <div class="year-col-body">

                  <!-- prev arrears -->
                  <div class="amount-row" v-if="parseFloat(r.computed.previousYearArrears) > 0">
                    <div class="amount-row-left">
                      <span class="amount-dot dot-arrears"></span>
                      <span class="amount-label">Arrears</span>
                      <span class="vote-tag" v-if="r.arrears_vote">{{ r.arrears_vote }}</span>
                    </div>
                    <span class="amount-value">Rs. {{ fmt(r.computed.previousYearArrears) }}</span>
                  </div>

                  <!-- prev fine -->
                  <div class="amount-row" v-if="parseFloat(r.computed.prefineamount) > 0">
                    <div class="amount-row-left">
                      <span class="amount-dot dot-fine"></span>
                      <span class="amount-label">Fine</span>
                      <span class="vote-tag" v-if="r.fine_vote">{{ r.fine_vote }}</span>
                    </div>
                    <span class="amount-value amount-value--fine">Rs. {{ fmt(r.computed.prefineamount) }}</span>
                  </div>

                  <div class="year-subtotal">
                    <span>Sub-total</span>
                    <span>Rs. {{ fmt(r.computed.prevYearTotal) }}</span>
                  </div>
                </div>
              </div>

              <!-- Current Year column -->
              <div class="year-col">
                <div class="year-col-header year-col-header--curr">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor" width="14" height="14">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/>
                  </svg>
                  Current Year
                </div>
                <div class="year-col-body">

                  <!-- curr arrears -->
                  <div class="amount-row" v-if="parseFloat(r.computed.currentYearArrears) > 0">
                    <div class="amount-row-left">
                      <span class="amount-dot dot-arrears"></span>
                      <span class="amount-label">Arrears</span>
                      <span class="vote-tag" v-if="r.rent_vote">{{ r.rent_vote }}</span>
                    </div>
                    <span class="amount-value">Rs. {{ fmt(r.computed.currentYearArrears) }}</span>
                  </div>

                  <!-- curr fine -->
                  <div class="amount-row" v-if="parseFloat(r.computed.fine) > 0">
                    <div class="amount-row-left">
                      <span class="amount-dot dot-fine"></span>
                      <span class="amount-label">Fine</span>
                      <span class="vote-tag" v-if="r.fine_vote">{{ r.fine_vote }}</span>
                    </div>
                    <span class="amount-value amount-value--fine">Rs. {{ fmt(r.computed.fine) }}</span>
                  </div>

                  <!-- monthly rent due -->
                  <div class="amount-row" v-if="parseFloat(r.computed.monthlyRentDue) > 0">
                    <div class="amount-row-left">
                      <span class="amount-dot dot-rent"></span>
                      <span class="amount-label">Monthly Rent</span>
                      <span class="vote-tag" v-if="r.rent_vote">{{ r.rent_vote }}</span>
                    </div>
                    <span class="amount-value">Rs. {{ fmt(r.computed.monthlyRentDue) }}</span>
                  </div>

                  <div class="year-subtotal">
                    <span>Sub-total</span>
                    <span>Rs. {{ fmt(r.computed.currYearTotal) }}</span>
                  </div>
                </div>
              </div>

            </div><!-- /year-columns -->

            <!-- Grand total -->
            <div class="grand-total-row">
              <span class="grand-total-label">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                  stroke="currentColor" width="16" height="16">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z"/>
                </svg>
                Total Payable
              </span>
              <span class="grand-total-value">Rs. {{ fmt(r.computed.totalAmount) }}</span>
            </div>

          </div><!-- /v-for shop-card -->

          <!-- Remarks + Submit -->
          <div class="form-card" style="margin-top:1.6rem;">
            <div class="card-header">
              <div class="step-badge">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>
                </svg>
              </div>
              <div>
                <h2 class="card-title">Payment Remarks</h2>
                <p class="card-desc">ගෙවීම් විස්තරය | Add a description for this payment</p>
              </div>
            </div>
            <div class="field-group">
              <label class="field-label" for="rentShopdes">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z"/>
                </svg>
                Remarks | ගෙවීම් විස්තරය
              </label>
              <textarea id="rentShopdes" class="field-input field-textarea"
                placeholder="Type your payment description here..."
                v-model="rentObj.rentdes"
                :class="{ filled: rentObj.rentdes }"></textarea>
              <p class="error-mess" v-if="errorObj.rentdesErr.length > 0">{{ errorObj.rentdesErr[0] }}</p>
            </div>
            <div class="form-actions">
              <div class="selection-summary" v-if="checkVal.length > 0">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                </svg>
                {{ checkVal.length }} shop{{ checkVal.length > 1 ? 's' : '' }} selected
                &nbsp;·&nbsp; Total: Rs. {{ fmt(selectedTotal) }}
              </div>
              <div class="no-selection" v-else>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
                </svg>
                Please select a shop to continue
              </div>
              <button type="submit" class="submit-btn" :disabled="checkVal.length === 0">
                Continue to Payment
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7l5 5m0 0l-5 5m5-5H6"/>
                </svg>
              </button>
            </div>
          </div>

        </div><!-- /#pay -->

        <!-- ── No Shops Found ── -->
        <div id="pay2" style="display:none;">
          <div class="form-card notice-card">
            <div class="notice-icon-wrap">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
              </svg>
            </div>
            <div>
              <h3 class="notice-title">No Shops Found</h3>
              <p class="notice-msg">No shop records were found for this Sabha under your name. Please select the correct council.</p>
              <p class="notice-sin">ඔබගේ කඩ කාමර කුලිය ගෙවීම සඳහා, ඔබගේ කඩ කාමරය අයත් සභාව නිවැරදිව තෝරන්න.</p>
            </div>
          </div>
        </div>

      </form>
    </div>
  </section>
</template>


<script>
import axios from "axios";
import { mapMutations, mapState } from "vuex";
import VueBasicAlert from 'vue-basic-alert';

export default {
  name: "ShopRentExist",
  components: { VueBasicAlert },

  data() {
    return {
      Nic: '',
      rentObj:  { pra_sabha: "", rentdes: "" },
      errorObj: { praErr: [], rentdesErr: [] },
      p_sabha: [],
      matchUser: undefined,
      checkVal: [],
      AllShopDetails: [],
      currentDate: new Date(),
      serverDate: '',
      onlinPaydata: [],
      nextid: '',
      finedate: 0,
      fineRate: 0,
    };
  },

  created() {
    this.getSessionData();
    this.AllprSabha();
  },

  computed: {
    ...mapState(["user"]),

    computedShopDetails() {
      return this.AllShopDetails.map(r => ({
        ...r,
        computed: this.calcShopAmounts(r),
      }));
    },

    selectedTotal() {
      return this.computedShopDetails
        .filter(r => this.checkVal.includes(r.shop_details_id))
        .reduce((s, r) => s + parseFloat(r.computed.totalAmount || 0), 0)
        .toFixed(2);
    },
  },

  methods: {
    ...mapMutations(["setUser"]),

    scrollToTop() { window.scrollTo(0, 0); },

    fmt(val) {
      return parseFloat(val || 0).toLocaleString('en-LK', {
        minimumFractionDigits: 2, maximumFractionDigits: 2,
      });
    },

    async MatchUser(nic) {
      const data = await axios.get('/customersdata/' + nic);
      this.matchUser = data.data;
    },

    // 1-based month name — identical to SubjectDashboard's getMonthName
    getMonthNameByNum(n) {
      const m = ['January','February','March','April','May','June',
                 'July','August','September','October','November','December'];
      return (n >= 1 && n <= 12) ? m[n - 1] : 'Invalid';
    },

    // "Next due" display label — mirrors SubjectDashboard template conditions
    nextDueLabel(r) {
      const cm = this.currentDate.getMonth() + 1;
      const cy = this.currentDate.getFullYear();
      if (r.pay_month > cm && r.pay_year === cy)
        return `${cy} – ${this.getMonthNameByNum(r.pay_month + 1)}`;
      if (r.pay_month < cm && r.pay_year === cy)
        return `${cy} – ${this.getMonthNameByNum(cm + 1)}`;
      if (r.pay_month < cm && r.pay_year > cy)
        return `${cy + 1} – ${this.getMonthNameByNum(r.pay_month + 1)}`;
      return `${cy} – ${this.getMonthNameByNum(cm + 1)}`;
    },

    // Identical to SubjectDashboard: return this.currentDate.getDate() > this.finedate
    isGreaterThan10th(finedate) {
      return this.currentDate.getDate() > finedate;
    },

    // Identical to SubjectDashboard's getPaymentOfMonth
    getPaymentOfMonth(paymonth1, rent, pyear) {
      if (paymonth1 === (this.currentDate.getMonth() + 1) &&
          pyear     ===  this.currentDate.getFullYear()) return 0;
      return parseFloat(rent);
    },

    // IDENTICAL to SubjectDashboard's DiffOfMonthstwoYear
    DiffOfMonthstwoYear(pm, cr, current_arrears, payYear) {
      if (pm < 1 || pm > 12) throw new Error('Month must be between 1 and 12');

      const d  = new Date(this.serverDate);
      const cm = d.getMonth() + 1;
      const cy = d.getFullYear();

      cr              = parseFloat(cr)              || 0;
      current_arrears = parseFloat(current_arrears) || 0;

      const totalMonths   = (cy - payYear) * 12 + (cm - pm);
      const arrearsMonths = totalMonths - 1;

      if (arrearsMonths <= 0) {
        return {
          currentYearDiff: 0, previousYearDiff: 0,
          currentYearArrears: "0.00", previousYearArrears: "0.00",
        };
      }

      const currentYearDiff  = Math.min(arrearsMonths, cm - 1);
      const previousYearDiff = arrearsMonths - currentYearDiff;

      let prevYearArrears = previousYearDiff * cr;
      let curArrears      = currentYearDiff  * cr;

      if (previousYearDiff > 0) prevYearArrears += current_arrears;
      else                       curArrears      += current_arrears;

      return {
        currentYearDiff,
        previousYearDiff,
        currentYearArrears:  curArrears.toFixed(2),
        previousYearArrears: prevYearArrears.toFixed(2),
      };
    },

    // Per-row calculation — mirrors SubjectDashboard's selectShops() logic exactly.
    // Vote codes read directly from shop_details:
    //   r.rent_vote    → monthly rent & current-year arrears
    //   r.arrears_vote → previous-year arrears
    //   r.fine_vote    → all fine amounts (prev + curr)
    calcShopAmounts(r) {
      const monthlyRent        = parseFloat(r.monthly_shop_rent) || 0;
      const fineRatePercentage = parseFloat(r.fine_rate || this.fineRate) / 100;
      const finedate           = r.fine_date          || this.finedate;
      const fineMonthCount     = parseInt(r.fine_month_count) || 0;
      const excessArrears      = parseFloat(r.arrears) || 0;

      // Split into previous-year / current-year (identical to SubjectDashboard)
      const split = this.DiffOfMonthstwoYear(
        r.pay_month, r.monthly_shop_rent, r.arrears, r.pay_year
      );

      let cyArrears = parseFloat(split.currentYearArrears);
      let pyArrears = parseFloat(split.previousYearArrears);

      // Adjust for fine_month_count (same as SubjectDashboard selectShops)
      if (fineMonthCount > 0) {
        cyArrears = Math.max(0, cyArrears - (monthlyRent * fineMonthCount));
      }

      // Monthly rent due this period
      const monthlyRentDue = this.getPaymentOfMonth(r.pay_month, r.monthly_shop_rent, r.pay_year);

      // Fine calculation — IDENTICAL to SubjectDashboard selectShops()
      let fine = 0;
      let prefineamount = 0;

      if (monthlyRent > 0) {
        let numarr    = cyArrears > 0 ? cyArrears / monthlyRent : 0;
        let numarrpre = pyArrears > 0 ? pyArrears / monthlyRent : 0;

        if (this.isGreaterThan10th(finedate) &&
            parseFloat(r.fine_rate || this.fineRate) > 0 &&
            monthlyRentDue !== 0) {
          numarr += 1;
        }

        fine = cyArrears > 0
          ? (numarr > 0 ? monthlyRent * fineRatePercentage * numarr : 0)
          : (monthlyRent * fineRatePercentage * numarr);

        prefineamount = pyArrears > 0
          ? (numarrpre > 0 ? monthlyRent * fineRatePercentage * numarrpre : 0)
          : 0;
      }

      // When cyArrears resolved to 0, use stored excess/negative arrears for display
      const cyArrearsDisplay = cyArrears > 0 ? cyArrears
                             : (excessArrears < 0 ? excessArrears : 0);

      const prevYearTotal = pyArrears + prefineamount;
      const currYearTotal = parseFloat(cyArrearsDisplay) + fine + monthlyRentDue;
      const totalAmount   = prevYearTotal + currYearTotal;

      return {
        previousYearArrears: pyArrears.toFixed(2),
        prefineamount:        prefineamount.toFixed(2),
        currentYearArrears:   parseFloat(cyArrearsDisplay).toFixed(2),
        fine:                 fine.toFixed(2),
        monthlyRentDue:       parseFloat(monthlyRentDue).toFixed(2),
        prevYearTotal:        prevYearTotal.toFixed(2),
        currYearTotal:        currYearTotal.toFixed(2),
        totalAmount:          totalAmount.toFixed(2),
      };
    },

    // ── Init ─────────────────────────────────────────────────────────────────
    async getSessionData() {
      const data = JSON.parse(sessionStorage.getItem('Userdata'));
      if (data) { this.Nic = data.Unic; }
      await this.MatchUser(this.Nic);
      this.setUser(this.matchUser);
      try {
        const res        = await axios.get('/getserverdate');
        this.serverDate  = res.data.serverDate;
        this.currentDate = new Date(this.serverDate);
      } catch (e) { console.error("Error fetching server date:", e); }
      await axios.delete('/shoprentstemp/'     + this.user.cus_nic);
      await axios.delete('/onlinepaymenttemp/' + this.user.cus_nic);
      sessionStorage.removeItem('rentDetails');
      sessionStorage.removeItem('shopDataid');
    },

    async AllprSabha() {
      try {
        const res = await axios.get('/customersabha/' + this.Nic);
        const all = res.data;
        if (all && all.length > 0) {
          this.p_sabha = [];
          for (const sabha of all) {
            if (sabha.sabha) {
              const r = await axios.get('/PraSabhadata/' + sabha.sabha);
              this.p_sabha.push(...r.data);
            }
          }
        }
      } catch (e) { console.error('Error fetching sabha data:', e); }
    },

    async AllShopData() {
      try {
        const shopData = (await axios.get(
          '/shopdata/' + this.Nic + '/' + this.rentObj.pra_sabha
        )).data;
        this.AllShopDetails = shopData;

        // Sabha-level fine config as fallback when shop_details fields are absent
        const theSabha = (await axios.get('/pra_sabha/' + this.rentObj.pra_sabha)).data;
        this.finedate  = theSabha.fine_date;
        this.fineRate  = theSabha.fine_rate;

        document.getElementById('pay').style.display  = shopData.length ? 'block' : 'none';
        document.getElementById('pay2').style.display = shopData.length ? 'none'  : 'block';
      } catch (e) { console.error("Error in AllShopData():", e); }
    },

    // ── Validation ────────────────────────────────────────────────────────────
    resetCheckErr() { this.errorObj.praErr = []; this.errorObj.rentdesErr = []; },
    checkEmptyErr()  { return Object.values(this.errorObj).every(a => a.length === 0); },
    checkForm() {
      this.resetCheckErr();
      if (!this.rentObj.pra_sabha) this.errorObj.praErr.push("Sabha selection is required");
    },

    // ── Submit ────────────────────────────────────────────────────────────────
    async handleSubmit(e) {
      e.preventDefault();
      this.checkForm();
      if (!this.checkEmptyErr()) return;
      if (!this.user)            { this.$refs.alert.showAlert('error', 'Please Login to Continue!'); return; }
      if (!this.checkVal.length) { this.$refs.alert.showAlert('error', 'Please select a shop'); return; }

      sessionStorage.setItem('shopDataid', JSON.stringify(this.checkVal));

      this.onlinPaydata = (await axios.get('/genarateinvonline/' + this.rentObj.pra_sabha)).data;
      const lastGennum = parseInt(this.onlinPaydata[0].gen_num);
      const InvouceNum = this.rentObj.pra_sabha.concat(
        this.currentDate.getMonth() + 1,
        this.currentDate.getFullYear(),
        lastGennum
      );
      this.nextid = lastGennum + 1;
      await axios.put('/updateinvonline/' + this.rentObj.pra_sabha, { gen_num: this.nextid });

      sessionStorage.setItem('rentDetails', JSON.stringify({
        sabha_code: this.rentObj.pra_sabha,
        remark:     this.rentObj.rentdes,
        month:      this.currentDate.getMonth() + 1,
        year:       this.currentDate.getFullYear(),
        invoiceNum: InvouceNum,
      }));

      this.$router.push("/ShoprentInvoice2");
    },
  },
};
</script>


<style scoped>
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500;9..40,600;9..40,700&family=DM+Serif+Display&display=swap');

* { box-sizing: border-box; }

.shoprent-page {
  min-height: 100vh;
  background: #f2f0ec;
  font-family: 'DM Sans', sans-serif;
  padding: 2rem 1.5rem 4rem;
}
.page-body { max-width: 1000px; margin: 0 auto; }

/* ── Login prompt ── */
.login-prompt { display: flex; align-items: center; justify-content: center; min-height: 80vh; }
.login-card {
  background: #fff; border-radius: 1.4rem; padding: 4rem 3.5rem;
  text-align: center; max-width: 420px; width: 100%;
  box-shadow: 0 8px 30px rgba(100,50,30,.10);
}
.login-icon {
  width: 6rem; height: 6rem;
  background: linear-gradient(135deg, #7c2d12, #c2440a);
  border-radius: 50%; display: flex; align-items: center; justify-content: center;
  margin: 0 auto 1.8rem;
}
.login-icon svg { width: 2.8rem; height: 2.8rem; stroke: #fff; }
.login-card h2 { font-family: 'DM Serif Display', serif; font-size: 2.2rem; color: #1c0f0a; margin: 0 0 .8rem; }
.login-card p  { font-size: 1.4rem; color: #7a6258; margin: 0 0 2rem; }
.login-btn {
  display: inline-block; padding: 1rem 2.6rem;
  background: linear-gradient(135deg, #7c2d12, #c2440a);
  color: #fff; border-radius: .8rem; font-size: 1.45rem; font-weight: 600;
  text-decoration: none; transition: all .2s;
}
.login-btn:hover { transform: translateY(-1px); box-shadow: 0 6px 18px rgba(124,45,18,.35); }

/* ── Page header ── */
.page-header {
  display: flex; align-items: flex-start; justify-content: space-between;
  margin-bottom: 2.2rem; gap: 1.5rem; flex-wrap: wrap;
}
.header-left { display: flex; align-items: flex-start; gap: 1.4rem; }
.header-bar {
  width: 5px; min-height: 72px; border-radius: 99px;
  background: linear-gradient(180deg, #7c2d12, #c2440a);
  flex-shrink: 0; margin-top: 4px;
}
.breadcrumb-label { font-size: 1.2rem; font-weight: 500; letter-spacing: .12em; text-transform: uppercase; color: #9a6652; margin: 0 0 .3rem; }
.page-title { font-family: 'DM Serif Display', serif; font-size: 2.6rem; color: #1c0f0a; margin: 0 0 .3rem; }
.page-subtitle { font-size: 1.3rem; color: #9a8070; margin: 0; }
.history-btn {
  display: inline-flex; align-items: center; gap: .6rem;
  padding: .85rem 1.8rem; border: 1.5px solid #c2440a;
  color: #c2440a; background: #fff; border-radius: .8rem;
  font-size: 1.35rem; font-weight: 500; text-decoration: none; transition: all .2s; white-space: nowrap;
}
.history-btn svg { width: 1.6rem; height: 1.6rem; }
.history-btn:hover { background: #c2440a; color: #fff; }

/* ── Generic form card ── */
.form-card {
  background: #fff; border: 1px solid #e5ddd5;
  border-radius: 1.2rem; padding: 2rem 2.2rem;
  box-shadow: 0 1px 4px rgba(100,50,30,.06);
  margin-bottom: 1.6rem;
}
.card-header {
  display: flex; align-items: center; gap: 1.4rem;
  margin-bottom: 1.8rem; padding-bottom: 1.4rem; border-bottom: 1px solid #f0e6de;
}
.step-badge {
  width: 3.8rem; height: 3.8rem; border-radius: 50%;
  background: linear-gradient(135deg, #7c2d12, #c2440a);
  display: flex; align-items: center; justify-content: center; flex-shrink: 0;
}
.step-badge svg { width: 1.8rem; height: 1.8rem; stroke: #fff; }
.card-title { font-family: 'DM Serif Display', serif; font-size: 1.75rem; color: #1c0f0a; margin: 0 0 .15rem; }
.card-desc  { font-size: 1.25rem; color: #9a8070; margin: 0; }

/* ── Fields ── */
.field-group { display: flex; flex-direction: column; gap: .5rem; }
.field-label {
  display: flex; align-items: center; gap: .5rem;
  font-size: 1.2rem; font-weight: 600; color: #4a3028;
}
.field-label svg { width: 1.4rem; height: 1.4rem; stroke: #c2440a; flex-shrink: 0; }
.req { color: #c2440a; }
.input-wrap { position: relative; }
.field-input {
  width: 100%; padding: .75rem 1.1rem;
  font-size: 1.3rem; font-family: 'DM Sans', sans-serif;
  color: #1c0f0a; background: #faf8f6;
  border: 2px solid #e5ddd5; border-radius: .7rem; transition: all .2s;
}
.field-input:focus { outline: none; border-color: #c2440a; background: #fff; box-shadow: 0 0 0 3px rgba(194,68,10,.09); }
.field-input.filled { background: #fff; border-color: #c2440a; }
.field-input::placeholder { color: #b0a09a; }
.field-textarea { min-height: 8rem; resize: vertical; }
.select-input { appearance: none; -webkit-appearance: none; cursor: pointer; padding-right: 3rem; }
.select-chevron {
  position: absolute; right: .9rem; top: 50%; transform: translateY(-50%);
  width: 1.5rem; height: 1.5rem; color: #9a8070; pointer-events: none;
}
.select-chevron svg { width: 100%; height: 100%; }
.error-mess { font-size: 1.15rem; color: #b91c1c; margin: 0; }
.error-mess::before { content: '⚠ '; }

/* ── Info banner ── */
.info-banner {
  display: flex; gap: 1.2rem; align-items: flex-start;
  background: #fdf8f0; border: 1px solid #f0ddc8;
  border-radius: .9rem; padding: 1.4rem 1.6rem; margin-bottom: 1.6rem;
}
.info-icon { width: 2.2rem; height: 2.2rem; flex-shrink: 0; margin-top: .1rem; }
.info-icon svg { width: 100%; height: 100%; stroke: #c2440a; }
.info-text p { font-size: 1.25rem; color: #4a3028; margin: 0 0 .5rem; line-height: 1.65; }
.info-text p:last-child { margin: 0; }
.sin-text { color: #7c5a48 !important; font-style: italic; }

/* ── Shop card ── */
.shop-card {
  background: #fff;
  border: 1.5px solid #e5ddd5;
  border-radius: 1.2rem;
  margin-bottom: 1.4rem;
  overflow: hidden;
  transition: border-color .2s, box-shadow .2s;
}
.shop-card--selected {
  border-color: #c2440a;
  box-shadow: 0 0 0 3px rgba(194,68,10,.10);
}

/* card top */
.shop-card-top {
  display: flex; align-items: center; justify-content: space-between;
  padding: 1.2rem 1.6rem;
  border-bottom: 1px solid #f0e6de;
  gap: 1rem; flex-wrap: wrap;
}
.shop-identity { display: flex; align-items: center; gap: 1rem; flex: 1; min-width: 0; }
.shop-num-badge {
  flex-shrink: 0;
  min-width: 3.4rem; height: 3.4rem;
  padding: 0 .6rem;
  background: linear-gradient(135deg, #7c2d12, #c2440a);
  color: #fff; border-radius: .7rem;
  display: flex; align-items: center; justify-content: center;
  font-size: 1.15rem; font-weight: 700; letter-spacing: .02em;
}
.shop-identity-info { min-width: 0; }
.shop-place { font-size: 1.3rem; font-weight: 600; color: #1c0f0a; margin: 0 0 .3rem; }
.shop-meta  {
  font-size: 1.1rem; color: #9a8070; margin: 0;
  display: flex; flex-wrap: wrap; align-items: center; gap: .3rem .5rem;
}
.shop-meta strong { color: #4a3028; }
.meta-sep { color: #c8b8b0; }

/* checkbox */
.custom-check-wrap { display: flex; align-items: center; justify-content: center; cursor: pointer; flex-shrink: 0; }
.hidden-check { display: none; }
.custom-check {
  width: 2.4rem; height: 2.4rem; border-radius: .5rem;
  border: 2px solid #d4c8be; background: #faf8f6;
  display: flex; align-items: center; justify-content: center; transition: all .18s;
}
.custom-check:hover { border-color: #c2440a; }
.custom-check.checked {
  background: linear-gradient(135deg, #7c2d12, #c2440a);
  border-color: transparent; box-shadow: 0 2px 8px rgba(124,45,18,.3);
}
.custom-check svg { width: 1.4rem; height: 1.4rem; stroke: #fff; }

/* ── Two-column year layout ── */
.year-columns {
  display: grid;
  grid-template-columns: 1fr 1fr;
  border-bottom: 1px solid #f0e6de;
}
.year-col { padding: 1.3rem 1.6rem; }
.year-col + .year-col { border-left: 1px solid #f0e6de; }

.year-col-header {
  display: flex; align-items: center; gap: .45rem;
  font-size: 1.05rem; font-weight: 600;
  text-transform: uppercase; letter-spacing: .07em;
  margin-bottom: 1rem; padding-bottom: .55rem;
  border-bottom: 2px solid transparent;
}
.year-col-header svg { flex-shrink: 0; }
.year-col-header--prev { color: #7c4a2a; border-bottom-color: #e8c8a8; }
.year-col-header--curr { color: #1a4f7c; border-bottom-color: #a8cce8; }

.year-col-body { display: flex; flex-direction: column; gap: .55rem; }

/* individual amount rows */
.amount-row {
  display: flex; align-items: center; justify-content: space-between;
  gap: .5rem; padding: .5rem .75rem;
  background: #faf8f6; border-radius: .5rem;
  border: 1px solid #f0ebe3;
}
.amount-row-left {
  display: flex; align-items: center; gap: .5rem; flex: 1; min-width: 0;
}
.amount-dot { width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; }
.dot-arrears { background: #c2440a; }
.dot-fine    { background: #b91c1c; }
.dot-rent    { background: #166534; }

.amount-label { font-size: 1.15rem; color: #4a3028; font-weight: 500; }
.vote-tag {
  font-size: .95rem; font-family: 'DM Mono', monospace;
  background: #f0ebe3; color: #7c4a2a;
  border-radius: .3rem; padding: .1rem .45rem;
  white-space: nowrap; flex-shrink: 0;
}
.amount-value {
  font-size: 1.2rem; font-weight: 600; color: #1c0f0a;
  white-space: nowrap; flex-shrink: 0;
  font-variant-numeric: tabular-nums;
}
.amount-value--fine { color: #b91c1c; }

/* sub-total line inside each column */
.year-subtotal {
  display: flex; justify-content: space-between; align-items: center;
  margin-top: .3rem; padding-top: .6rem;
  border-top: 1px dashed #e5ddd5;
  font-size: 1.15rem; font-weight: 600; color: #4a3028;
}

/* ── Grand total ── */
.grand-total-row {
  display: flex; align-items: center; justify-content: space-between;
  padding: 1rem 1.6rem;
  background: #fdf4f0;
}
.grand-total-label {
  display: flex; align-items: center; gap: .5rem;
  font-size: 1.2rem; font-weight: 600; color: #7c2d12;
}
.grand-total-label svg { stroke: #7c2d12; flex-shrink: 0; }
.grand-total-value {
  font-size: 1.6rem; font-weight: 700; color: #7c2d12;
  font-variant-numeric: tabular-nums;
}

/* ── Form actions ── */
.form-actions {
  display: flex; align-items: center; justify-content: space-between;
  gap: 1.2rem; flex-wrap: wrap;
  padding-top: 1.6rem; margin-top: 1.5rem; border-top: 1px solid #f0e6de;
}
.selection-summary {
  display: flex; align-items: center; gap: .6rem;
  font-size: 1.3rem; font-weight: 600; color: #166534;
  background: #dcfce7; border: 1px solid #bbf7d0;
  border-radius: 99px; padding: .5rem 1.3rem;
}
.selection-summary svg { width: 1.5rem; height: 1.5rem; stroke: #166534; }
.no-selection {
  display: flex; align-items: center; gap: .6rem;
  font-size: 1.25rem; color: #9a8070;
  background: #faf8f6; border: 1px solid #e5ddd5;
  border-radius: 99px; padding: .5rem 1.3rem;
}
.no-selection svg { width: 1.4rem; height: 1.4rem; stroke: #c2440a; }
.submit-btn {
  display: inline-flex; align-items: center; gap: .7rem;
  padding: .95rem 2.6rem;
  background: linear-gradient(135deg, #7c2d12, #c2440a);
  color: #fff; border: none; border-radius: .8rem;
  font-family: 'DM Sans', sans-serif; font-size: 1.45rem; font-weight: 700;
  cursor: pointer; box-shadow: 0 4px 16px rgba(124,45,18,.28); transition: all .2s;
}
.submit-btn svg { width: 1.7rem; height: 1.7rem; }
.submit-btn:hover:not(:disabled) { transform: translateY(-2px); box-shadow: 0 8px 24px rgba(124,45,18,.38); }
.submit-btn:disabled { opacity: .5; cursor: not-allowed; }

/* ── Empty / notice ── */
.empty-card { text-align: center; }
.empty-row  { font-size: 1.4rem; color: #9a8070; font-style: italic; padding: 2rem 0; margin: 0; }
.notice-card { display: flex; align-items: flex-start; gap: 1.8rem; border-color: #fde8c8; background: #fffbf5; }
.notice-icon-wrap {
  width: 4.5rem; height: 4.5rem; flex-shrink: 0;
  background: #fff4e0; border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
}
.notice-icon-wrap svg { width: 2.4rem; height: 2.4rem; stroke: #c2440a; }
.notice-title { font-family: 'DM Serif Display', serif; font-size: 1.65rem; color: #1c0f0a; margin: 0 0 .5rem; }
.notice-msg   { font-size: 1.3rem; color: #4a3028; margin: 0 0 .4rem; line-height: 1.5; }
.notice-sin   { font-size: 1.2rem; color: #9a8070; margin: 0; font-style: italic; }

/* ── Responsive ── */
@media (max-width: 900px) {
  .shoprent-page { padding: 1.5rem 1rem 3rem; }
  .page-title { font-size: 2.2rem; }
}
@media (max-width: 768px) {
  .page-header  { flex-direction: column; }
  .form-card    { padding: 1.5rem; }
  .form-actions { flex-direction: column; align-items: stretch; }
  .submit-btn   { justify-content: center; }
  .year-columns { grid-template-columns: 1fr; }
  .year-col + .year-col { border-left: none; border-top: 1px solid #f0e6de; }
}
@media (max-width: 520px) {
  .page-title         { font-size: 1.9rem; }
  .notice-card        { flex-direction: column; }
  .shop-card-top      { flex-direction: column; align-items: flex-start; }
  .grand-total-value  { font-size: 1.4rem; }
}
</style>